// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"307":"f279e75b","903":"163522e0"}[chunkId] + ".chunk.css";
};